import {
    HOST_URL,
    PRE_FIX_ROUTE,
    RENTAL_ROUTE,
    FIXED_RENTAL_ROUTE,
    EXTRA_SERVICE_ROUTE,
    USER_ROUTE,
    BILLING_ROUTE,
    TRANSACTION_ROUTE,
    NOTIFICATIONS_ROUTE,
    RATING_ROUTE,
    COUPONS_ROUTE,
    USER_HISTORY_ROUTE,
    SNAPSHOT_ROUTE,
    API_ROUTE,
    NEWS_ROUTE,
    CHAT_HISTORY_ROUTE,
} from "@/constant/routeApi";

//#region User
export const SETTINGS_USER_API = {

    // Change password
    CHANGE_PASSWORD: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.CHANGE_PASSWORD
    },

    // Profile settings ___ View
    PROFILE_SETTINGS_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.PROFILE_SETTINGS_VIEW
    },

    // Profile settings ___ Modify
    PROFILE_SETTINGS_MODIFY: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.PROFILE_SETTINGS_MODIFY
    },

    // Invoice billing settings ___ View
    INVOICE_BILLING_SETTINGS_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.INVOICE_BILLING_SETTINGS_VIEW
    },

    // Invoice billing settings ___ Modify
    INVOICE_BILLING_SETTINGS_MODIFY: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.INVOICE_BILLING_SETTINGS_MODIFY
    },

    // Notification settings ___ View
    NOTIFICATION_SETTINGS_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.NOTIFICATION_SETTINGS_VIEW
    },

    // Notification settings ___ Modify
    NOTIFICATION_SETTINGS_MODIFY: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.NOTIFICATION_SETTINGS_MODIFY
    },

    // Email settings ___ View
    EMAIL_SETTINGS_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.EMAIL_SETTINGS_VIEW
    },

    // Email settings ___ Modify
    EMAIL_SETTINGS_MODIFY: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.EMAIL_SETTINGS_MODIFY
    },

    // Enable Two-Factor Authentication settings ___ Modify
    GET_TWO_FACTOR_AUTH_INFO: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.GET_TWO_FACTOR_AUTH_INFO
    },
    ENABLE_TWO_FACTOR_AUTH: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.ENABLE_TWO_FACTOR_AUTH
    },
    DISABLE_TWO_FACTOR_AUTH: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.DISABLE_TWO_FACTOR_AUTH
    },
    IS_ENABLE_TWO_FACTOR_AUTH: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.IS_ENABLE_TWO_FACTOR_AUTH
    },
    PRE_LOGIN_CHECK_TWO_FACTOR_AUTH: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.PRE_LOGIN_CHECK_TWO_FACTOR_AUTH
    },
    IS_PARSEC_PRIME_ACTIVED: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.IS_PARSEC_PRIME_ACTIVED
    },
    PARSEC_PRIME_GET_INFO: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.PARSEC_PRIME_GET_INFO
    },
    ENABLE_DISABLE_PARSEC_PRIME: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.ENABLE_DISABLE_PARSEC_PRIME
    },
    SAVE_PARSEC_PRIME_SETTINGS: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.SAVE_PARSEC_PRIME_SETTINGS
    },
    LEAVE_TEAM_PARSEC_PRIME: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER,
        route: USER_ROUTE.LEAVE_TEAM_PARSEC_PRIME
    }
}
//#endregion

//#region Fixed rental
export const SETTINGS_FIXED_RENTAL_API = {

    // Fixed rental view
    FIXED_RENTAL_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.FIXED_RENTAL,
        route: FIXED_RENTAL_ROUTE.FIXED_RENTAL_VIEW
    },

    // Fixed rental create image
    FIXED_RENTAL_CREATE_IMAGE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.FIXED_RENTAL,
        route: FIXED_RENTAL_ROUTE.FIXED_RENTAL_CREATE_IMAGE
    },

    // Fixed rental create
    FIXED_RENTAL_CREATE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.FIXED_RENTAL,
        route: FIXED_RENTAL_ROUTE.FIXED_RENTAL_CREATE
    },

    // Fixed rental renewal
    FIXED_RENTAL_RENEWAL: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.FIXED_RENTAL,
        route: FIXED_RENTAL_ROUTE.FIXED_RENTAL_RENEWAL
    },

    // Fixed rental renewal machine
    FIXED_RENTAL_RENEWAL_MACHINE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.FIXED_RENTAL,
        route: FIXED_RENTAL_ROUTE.FIXED_RENTAL_RENEWAL_MACHINE
    },

    // Fixed rental deactivate
    FIXED_RENTAL_DEACTIVATE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.FIXED_RENTAL,
        route: FIXED_RENTAL_ROUTE.FIXED_RENTAL_DEACTIVATE
    },

    // Fixed rental settings
    FIXED_RENTAL_SETTINGS: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.FIXED_RENTAL,
        route: FIXED_RENTAL_ROUTE.FIXED_RENTAL_SETTINGS
    },
}
//#endregion

//#region Rental
export const SETTINGS_RENTAL_API = {

    // OS list view
    OPERATING_SYSTEM_LIST_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.OPERATING_SYSTEM_LIST_VIEW
    },

    // Master list view
    MASTER_LIST_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.MASTER_LIST_VIEW
    },

    // Change service package list view
    CHANGE_SERVICE_PACKAGE_LIST_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.CHANGE_SERVICE_PACKAGE_LIST_VIEW
    },

    // Change service package 
    CHANGE_SERVICE_PACKAGE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.CHANGE_SERVICE_PACKAGE
    },

    // Service package view
    SERVICE_PACKAGE_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.SERVICE_PACKAGE_VIEW
    },

    // Machine list view
    MACHINE_LIST_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.MACHINE_LIST_VIEW
    },

    // Create Image
    CREATE_IMAGE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.CREATE_IMAGE
    },

    // Boot machine
    BOOT_MACHINE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.BOOT_MACHINE
    },

    // Shutdown machine
    SHUTDOWN_MACHINE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.SHUTDOWN_MACHINE
    },

    // Remove image
    REMOVE_IMAGE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.REMOVE_IMAGE
    },

    // Rename image
    RENAME_IMAGE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.RENAME_IMAGE
    },

    // Clone image
    CLONE_IMAGE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.CLONE_IMAGE
    },

    // Rental request create
    RENTAL_REQUEST_CREATE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.RENTAL_REQUEST_CREATE
    },

    // Hardware fixation
    HARDWARE_FIXATION: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.HARDWARE_FIXATION
    },

    // Hardware fixation
    SETTINGS_MACHINE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.SETTINGS_MACHINE
    },

    // Scheduler machine
    SCHEDULER_MACHINE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.SCHEDULER_MACHINE
    },

    // Restart machine
    RESTART_MACHINE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.RESTART_MACHINE
    },

    // Reset machine
    RESET_MACHINE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.RESET_MACHINE
    },

    // Reset machine
    DISCONNECT_INTERNET_MACHINE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.DISCONNECT_INTERNET_MACHINE
    },

    // Reset machine
    ACTIVATE_SOFTWARE_LICENSE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.ACTIVATE_SOFTWARE_LICENSE
    },
}
//#endregion

//#region Extra service
export const SETTINGS_EXTRA_SERVICE_API = {

    // Create request
    CREATE_REQUEST: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.EXTRA_SERVICE,
        route: EXTRA_SERVICE_ROUTE.CREATE_REQUEST
    },

    // Check port
    CHECK_PORT: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.EXTRA_SERVICE,
        route: EXTRA_SERVICE_ROUTE.CHECK_PORT
    },

    // History view
    HISTORY_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.EXTRA_SERVICE,
        route: EXTRA_SERVICE_ROUTE.HISTORY_VIEW
    },
}
//#endregion

//#region Billing
export const SETTINGS_BILLING_API = {

    // History view
    BILLING_HISTORY_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.BILLING,
        route: BILLING_ROUTE.BILLING_HISTORY_VIEW
    },
}
//#endregion

//#region Transaction
export const SETTINGS_TRANSACTION_API = {

    // Recharge history view
    TRANSACTION_RECHARGE_HISTORY_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.TRANSACTION,
        route: TRANSACTION_ROUTE.TRANSACTION_RECHARGE_HISTORY_VIEW
    },

    // Coupon history view
    TRANSACTION_COUPON_HISTORY_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.TRANSACTION,
        route: TRANSACTION_ROUTE.TRANSACTION_COUPON_HISTORY_VIEW
    },

    // Export invoice
    TRANSACTION_EXPORT_INVOICE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.TRANSACTION,
        route: TRANSACTION_ROUTE.TRANSACTION_EXPORT_INVOICE
    },

    // No receipts
    TRANSACTION_NO_RECEIPTS: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.TRANSACTION,
        route: TRANSACTION_ROUTE.TRANSACTION_NO_RECEIPTS
    },
}
//#endregion

//#region Notifications
export const SETTINGS_NOTIFICATIONS_API = {

    // Notifications view
    NOTIFICATIONS_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.NOTIFICATIONS,
        route: NOTIFICATIONS_ROUTE.NOTIFICATIONS_VIEW
    },

    // Remove status
    NOTIFICATIONS_REMOVES_STATUS: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.NOTIFICATIONS,
        route: NOTIFICATIONS_ROUTE.NOTIFICATIONS_REMOVES_STATUS
    },

    // Mark status
    NOTIFICATIONS_MARK_STATUS: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.NOTIFICATIONS,
        route: NOTIFICATIONS_ROUTE.NOTIFICATIONS_MARK_STATUS
    },

    // Mark all read
    NOTIFICATIONS_MARK_ALL_READ: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.NOTIFICATIONS,
        route: NOTIFICATIONS_ROUTE.NOTIFICATIONS_MARK_ALL_READ
    },
}
//#endregion

//#region Rating
export const SETTINGS_RATING_API = {

    // Rating submit
    RATING_SUBMIT: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RATING,
        route: RATING_ROUTE.RATING_SUBMIT
    },
}
//#endregion

//#region Coupons
export const SETTINGS_COUPONS_API = {

    // Coupons view
    COUPONS_VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RATING,
        route: COUPONS_ROUTE.COUPONS_VIEW
    },
}
//#endregion

//#region User history
export const SETTINGS_USER_HISTORY_API = {

    // Activity log
    ACTIVITY_LOG: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.USER_HISTORY,
        route: USER_HISTORY_ROUTE.ACTIVITY_LOG
    },
}
//#endregion

//#region User history
export const SETTINGS_SNAPSHOT_API = {

    GET_SNAPSHOT_LIST: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.SNAPSHOT,
        route: SNAPSHOT_ROUTE.GET_SNAPSHOT_LIST
    },
    GET_SNAPSHOT_BY_ID: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.SNAPSHOT,
        route: SNAPSHOT_ROUTE.GET_SNAPSHOT_BY_ID
    },
    CHECK_CONDITIONAL_CREATE: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.SNAPSHOT,
        route: SNAPSHOT_ROUTE.CHECK_CONDITIONAL_CREATE
    },
    CREATE_SNAPSHOT: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.SNAPSHOT,
        route: SNAPSHOT_ROUTE.CREATE_SNAPSHOT
    },
    UPDATE_SNAPSHOT: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.SNAPSHOT,
        route: SNAPSHOT_ROUTE.UPDATE_SNAPSHOT
    },
    REMOVE_SNAPSHOT: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.SNAPSHOT,
        route: SNAPSHOT_ROUTE.REMOVE_SNAPSHOT
    },
    REMOVE_SNAPSHOT_BY_MACHINE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.SNAPSHOT,
        route: SNAPSHOT_ROUTE.REMOVE_SNAPSHOT_BY_MACHINE
    },
    RESTORE_SNAPSHOT: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.SNAPSHOT,
        route: SNAPSHOT_ROUTE.RESTORE_SNAPSHOT
    },

}

export const SETTINGS_DEVELOPER_API = {
    ENABLE_API: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.API,
        route: API_ROUTE.ENABLE_API
    },
    ADD_RESTRICTIONS: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.API,
        route: API_ROUTE.ADD_RESTRICTIONS
    },
    REMOVE_RESTRICTIONS: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.API,
        route: API_ROUTE.REMOVE_RESTRICTIONS
    },
    GET_API_INFO: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.API,
        route: API_ROUTE.GET_API_INFO
    },
}

export const SETTINGS_PROCESS_MONITORING_API = {
    VIEW: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.PROCESS_MONITORING_VIEW
    },
    REMOVE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.PROCESS_MONITORING_REMOVE
    },
    ENABLE: {
        method: 'POST',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.RENTAL,
        route: RENTAL_ROUTE.PROCESS_MONITORING_ENABLE
    },
}
//#endregion

export const SETTINGS_RENTAL_NEWS_API = {
    GET_IMPORTANT_NEWS: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.NEWS,
        route: NEWS_ROUTE.GET_IMPORTANT_NEWS
    },
    GET_ACTIVE_NEWS: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.NEWS,
        route: NEWS_ROUTE.GET_ACTIVE_NEWS
    },
}

export const SETTINGS_CHAT_HISTORY_API = {
    GET_CHAT_CONVERSATION: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.CHAT_HISTORY,
        route: CHAT_HISTORY_ROUTE.GET_CHAT_CONVERSATION
    },
    GET_CHAT_HISTORY: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.CHAT_HISTORY,
        route: CHAT_HISTORY_ROUTE.GET_CHAT_HISTORY
    },
    GET_CHAT_HISTORY_BY_CONVERSATION: {
        method: 'GET',
        hostUrl: HOST_URL.API_URL,
        prefixedRoute: PRE_FIX_ROUTE.CHAT_HISTORY,
        route: CHAT_HISTORY_ROUTE.GET_CHAT_HISTORY_BY_CONVERSATION
    },
}